export enum DriverCategory {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
